// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"496":"d883d5cf","613":"55f0c667"}[chunkId] + ".chunk.js";
};